import { render, staticRenderFns } from "./EduExampaper.vue?vue&type=template&id=fcc5d722&scoped=true"
import script from "./EduExampaper.vue?vue&type=script&lang=js"
export * from "./EduExampaper.vue?vue&type=script&lang=js"
import style0 from "./EduExampaper.vue?vue&type=style&index=0&id=fcc5d722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc5d722",
  null
  
)

export default component.exports